import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link } from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from "axios";
import logo from "../../../../assets/images/logo.png";
import { NuInput, NuInputToggle } from "../../../../Components/Utils/Input";
import { useToast } from "../../../../Components/Others/ToastServices";
import CryptoJS from "crypto-js";
import ChangePassword from "./changePassword";
import "../../../../App.css";
import { GetDashboardRole } from "../../../../Components/Utils/roles";

axios.defaults.baseURL = window.WEB_APP_API_URL;
function AnotherLogin() {
  const toast = useToast();
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleForgetPasswordClick = () => {
    setShowForgetPassword(true);
  };
  const handleCloseModal = () => {
    setShowForgetPassword(false);
  };
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("nEkOtReSuEdArT") &&
      localStorage.getItem("sLiAtEdReSuEdArT") &&
      localStorage.getItem("sSeCcArEsUeDaRt")
    ) {
      const hasMutipleOffice = localStorage.getItem("hasmutiple")
        ? JSON.parse(localStorage.getItem("hasmutiple"))
        : false;
      const branchId = localStorage.getItem("branchId")
        ? JSON.parse(localStorage.getItem("branchId"))
        : 1;
      window.location.replace(
        hasMutipleOffice == true
          ? "/main-page/dashboard"
          : GetDashboardRole("")
          ? `/main/${branchId}/dashboard`
          : GetDashboardRole("sales")
          ? `/main/${branchId}/dashboard/sales`
          : GetDashboardRole("procurement")
          ? `/main/${branchId}/dashboard/procurement`
          : GetDashboardRole("store")
          ? `/main/${branchId}/dashboard/stores`
          : `/main/${branchId}/dashboard`
      );
    }
  }, []);

  const encryptData = async (data, location) => {
    let Test = JSON.stringify(data);
    const Value = CryptoJS.AES.encrypt(
      Test,
      process.env.REACT_APP_ACCESS_KEY
    ).toString();
    localStorage.setItem(location, Value);
    // console.log('EnC',Value)
  };

  const [createNew, setCreateNew] = useState({
    email: "",
    password: "",
  });
  const formik = useFormik({
    initialValues: createNew,
    validateOnChange: false,
    validationSchema: yup.object({
      email: yup.string().required("Email is Required"),
      password: yup.string().required("Password is Required"),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);
      await axios
        .post("/auth/login", value)
        .then(async (res) => {
          if (res.data.status) {
            setIsLoading(false);
            let userToken = res?.data?.token;
            await encryptData(userToken, "nEkOtReSuEdArT");
            let decodeToken = jwt_decode(res?.data?.token);
            await encryptData(decodeToken, "sLiAtEdReSuEdArT");
            let permissions = res?.data?.permissions;
            await encryptData(permissions, "sSeCcArEsUeDaRt");
            localStorage.setItem("hasmutiple", res?.data?.has_multi_office);
            // localStorage.setItem('nEkOtReSuEdArT', JSON.stringify(res?.data?.token));
            // localStorage.setItem('sSeCcArEsUeDaRt', JSON.stringify(res?.data?.permissions));
            toast.open({
              message: "Login successfully",
              description: res.data.msg || "Successfully logged in  ",
              type: "success",
            });
            let branchId = res?.data?.branchId;
            localStorage.setItem("branchId", res?.data?.branchId);
            if (res?.data?.has_multi_office == true) {
              window.location.replace(`/main-page/dashboard`);
            } else {
              window.location.replace(
                GetDashboardRole("")
                  ? `/main/${branchId}/dashboard`
                  : GetDashboardRole("sales")
                  ? `/main/${branchId}/dashboard/sales`
                  : GetDashboardRole("procurement")
                  ? `/main/${branchId}/dashboard/procurement`
                  : GetDashboardRole("store")
                  ? `/main/${branchId}/dashboard/stores`
                  : `/main/${branchId}/dashboard`
              );

              // window.location.replace(GetDashboardRole("")?`/main/${branchId}/dashboard`:GetDashboardRole("sales")?`/main/${branchId}/dashboard/sales`:GetDashboardRole("procurement")?`/main/${branchId}/dashboard/procurement`:GetDashboardRole("store")?`/main/${branchId}/dashboard/stores`:`/main/${branchId}/dashboard`);
            }
          } else {
            setIsLoading(false);
            toast.open({
              message: "Login unsuccessfully",
              description: res.data.msg || "Login failed ",
              type: "error",
            });
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.open({
            message: "Login unsuccessfully",
            description:
              err?.response.data.msg || "Login failed or network error  ",
            type: "error",
          });
        });
    },
  });

  return (
    <div className="w-full h-[100vh] login-image">
      <div className="w-full h-[calc(100vh-30px)] flex items-center justify-end">
        {/* {contextHolder} */}
        {/* <div className='w-full mx-5 md:mx-0 md:w-3/5 h-2/3 rounded-2xl flex flex-col shadow-[0px_4px_16px_rgba(17,17,26,0.1),_0px_8px_24px_rgba(17,17,26,0.1),_0px_16px_56px_rgba(17,17,26,0.1)]'> */}
        {/* <div className='hidden md:flex w-1/2 bg-gradient-to-t to-teal-200 from-green-700  rounded-l-2xl flex-col items-center justify-center gap-6'>
            <h1 className='text-center text-[#231942] capitalize font-bold text-[20px] lg:text-[23px] xl:text-[26px]'>Login</h1>
            <div className='w-[65%] rounded-[1.5rem] content-center h-[65%] bg-[#e6f3f2] flex items-center justify-center drop-shadow-lg'>
              <img className='w-1/2' src={logo} alt="logo"/>
            </div>
          </div> */}
        <div className="w-full md:w-[30%] h-2/3 mr-40 rounded-2xl bg-baseColor-primary/20 backdrop-blur-sm flex justify-center items-center border border-solid border-white">
          <div className="w-full px-3 flex flex-col ">
            <div className="w-[65%] rounded-[1.5rem] content-center h-[65%] bg-[#e6f3f2] flex items-center justify-center drop-shadow-lg mx-auto mb-2">
              {/* <img className='w-1/2' src={logo} alt="logo"/> */}
              <p className=" text-3xl py-2 text-baseColor-primary">nupro</p>
            </div>
            <form onSubmit={formik.handleSubmit} className="">
              <div className=" justify-center ">
                <NuInput
                  type="text"
                  label="Email *"
                  placeholder="Enter Your Mail"
                  formik={formik}
                  name="email"
                  width="w-full"
                  padding="py-2"
                  color="white"
                />

                <NuInputToggle
                  label="Password *"
                  placeholder="************"
                  formik={formik}
                  name="password"
                  width="w-full"
                  padding="py-2"
                  color="white"
                />
              </div>

              {/* <Link to="/auth/forget-password"> */}
              <div className=" flex justify-end">
                <span
                  onClick={handleForgetPasswordClick}
                  className="text-white px-5 font-sans  not-italic text-sm medium text-right cursor-pointer"
                >
                  Forgot Password?
                </span>
              </div>
              {/* </Link> */}
              <button
                type="submit"
                className={`${
                  isLoading == true
                    ? "cursor-wait bg-[#d0f6f3]"
                    : "cursor-pointer bg-baseColor-primary"
                } border-none  text-white text-xs bg-baseColor-primary h-10  mx-6 mt-6 rounded-md w-[88%]`}
              >
                Login
              </button>
            </form>
          </div>
        </div>
        {/* </div> */}
      </div>
      <p className=" mt- font-semibold text-center text-s text-slate-200">
        &#169; numota
      </p>
      {showForgetPassword && <ChangePassword onClose={handleCloseModal} />}
    </div>
  );
}
export default AnotherLogin;
